import React, { useState, useContext, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import PageNavigations from "../breadcrumbs/PageNavigations";
import StudentAddRelatedList from "./studentAddRelatedList";
import { usePermissions } from "../contexts/PermissionContext";
import { SessionContext } from "../SessionProvider";
import schoolApi from "../../api/schoolApi";
import Student360Report from './Student360Report';

const StudentAddmissionView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id: admissionId } = useParams();

  const { rolePermissions, userInfo } = usePermissions();
  const canEdit = rolePermissions?.Students_Registration_List?.can_edit;
  const [studentaddmission, setStudentAddmission] = useState(null);
  const [studentAdmissionPayload, setStudentAdmissionPayload] = useState(null);

  // Add state for 360 preview modal
  const [show360Modal, setShow360Modal] = useState(false);
  const [studentData, setstudentData] = useState(null);

  const { selectedSessionId, setSelectedSessionId, currentSessionId } = useContext(SessionContext);
  const [isCurrentSession, setIsCurrentSession] = useState();
  const [hasPaidInstallments, setHasPaidInstallments] = useState(false);

  useEffect(() => {
    async function checkInstallments() {
      const targetId = studentaddmission?.student_addmission_id || studentaddmission?.id || admissionId;
      if (!targetId) return;
      if (Number(studentaddmission?.paid_installments_count || 0) > 0 || studentaddmission?.has_paid_installments) {
        setHasPaidInstallments(true);
        return;
      }
      try {
        const result = await schoolApi.fetchStudentFeeInstallments(targetId);
        if (result && result.success && result.result) {
          const anyPaid = result.result.some(
            (res) => res.status !== "pending" || Number(res?.deposit_amount) > 0
          );
          setHasPaidInstallments(anyPaid);
        }
      } catch (error) {
        console.log("Error checking installments:", error);
      }
    }
    checkInstallments();
  }, [studentaddmission, admissionId]);

  console.log("Student Admission View - studentaddmission:", studentaddmission);
  console.log("Student Admission View - location.state:", location.state);

  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== undefined) {
          setIsCurrentSession(selectedSessionId === currentSessionId);
        }
      } catch (error) {
        console.log('error=>', error);
      }
    }
    init();
  }, [selectedSessionId, currentSessionId]);

  useEffect(() => {
    let isMounted = true;

    const getBaseStudentData = () => {
      if (!location?.state) {
        return null;
      }
      return location.state.student_info || location.state;
    };

    const resolveStudentAdmission = async () => {
      try {
        const baseData = getBaseStudentData();
        if (baseData && isMounted) {
          setStudentAddmission(baseData);
          setStudentAdmissionPayload(location.state || { student_info: baseData });
        }

        const fallbackAdmission = await schoolApi.fetchStudentAddmissionById(admissionId);
        const fallbackAdmissionRecord = fallbackAdmission?.resultCon;

        const studentId =
          baseData?.studentid ||
          baseData?.student_id ||
          fallbackAdmissionRecord?.studentid ||
          baseData?.id;

        if (!studentId) {
          return;
        }

        const admissionsByStudent = await schoolApi.fetchAdmissionByStudentId(studentId);
        const matchedAdmission = admissionsByStudent?.studentAddmision?.find(
          (item) => item.id === admissionId
        );

        const resolvedSessionId =
          matchedAdmission?.session_id ||
          baseData?.session_id ||
          selectedSessionId;

        if (!resolvedSessionId) {
          if (matchedAdmission && isMounted) {
            setStudentAddmission((prev) => ({
              ...prev,
              ...matchedAdmission,
              id: matchedAdmission.studentid || matchedAdmission.student_id,
              studentid: matchedAdmission.studentid || matchedAdmission.student_id,
              student_addmission_id: matchedAdmission.id,
            }));
          }
          return;
        }

        const detailResponse = await schoolApi.fetchStudentAddmission(
          resolvedSessionId,
          studentId
        );
        const detailPayload = detailResponse?.studentAddmision?.[0];
        const studentDetails = detailResponse?.studentAddmision?.[0]?.student_info;

        if (detailPayload && isMounted) {
          setStudentAdmissionPayload(detailPayload);
        }

        if (studentDetails && isMounted) {
          setStudentAddmission({
            ...matchedAdmission,
            ...studentDetails,
            id: studentDetails.id || matchedAdmission?.studentid || matchedAdmission?.student_id,
            studentid:
              studentDetails.id ||
              matchedAdmission?.studentid ||
              matchedAdmission?.student_id,
            student_addmission_id:
              studentDetails.student_addmission_id || matchedAdmission?.id || admissionId,
            classname: studentDetails.class_name || matchedAdmission?.classname,
          });
        }
      } catch (error) {
        console.log("error=>", error);
      }
    };

    resolveStudentAdmission();

    return () => {
      isMounted = false;
    };
  }, [admissionId, location.state, selectedSessionId]);

  let msg = studentaddmission?.active !== undefined
    ? `Are you sure want to ${studentaddmission.active === true ? "Inactive" : "Active"} student`
    : "Are you sure want to change student status";

  const [modalShow, setModalShow] = useState(false);
  const [statusColor, setStatusColor] = useState("primary");

  const handleCancel = async () => {
    navigate("/studentaddmissions");
  };

  const editStudent = () => {
    navigate(`/student/${studentaddmission.student_addmission_id}/e`, {
      state:
        studentAdmissionPayload || {
          ...(location.state || {}),
          student_info: studentaddmission,
        },
    });
  };


  const handleValueFromChild = (value) => {
    setStudentAddmission(value);
    setStudentAdmissionPayload((prev) => ({
      ...(prev || location.state || {}),
      student_info: value,
    }));
    window.history.replaceState(
      { ...(location.state || {}), student_info: value },
      ""
    );
  };

  const handleFeeDepositClick = () => {
    const row = { student_info: studentaddmission };
    navigate("/feedepositeedit/e", {
      state: { row },
    });
  };

  // Handle Download 360 Click - Opens Modal with Student Data
  const handleDownloadClick = () => {
    console.log("Download 360 clicked for student:", studentaddmission);

    // Prepare complete student data for 360 view
    const completeStudentData = {
      student_info: studentaddmission,
      parent_info: studentAdmissionPayload?.parent_info || location.state?.parent_info || null,
      previous_school: studentAdmissionPayload?.previous_school || location.state?.previous_school || null,
      sibling_info: studentAdmissionPayload?.sibling_info || location.state?.sibling_info || null,
      admission_details: {
        admission_id: admissionId,
        session_id: selectedSessionId,
        is_current_session: isCurrentSession
      }
    };

    console.log("Complete 360 Data:", completeStudentData);
    setstudentData(completeStudentData);
    setShow360Modal(true);
  };

  // Close Modal
  const handleCloseModal = () => {
    setShow360Modal(false);
    setstudentData(null);
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <PageNavigations
        listName="Admissions Details"
        listPath="/studentaddmissions"
        colLg={2}
        colClassName="d-flex mx-5 mb-4"
        extrColumn={12}
      />
      <div>
        {studentaddmission && (
          <Container>
            <Row className="view-form">
              <Col lg={12}>
                <Row className="view-form-header align-items-center mx-3">
                  <Col lg={6}>
                    <h5>
                      {studentaddmission?.studentname
                        ? studentaddmission.studentname
                        : studentaddmission.firstname +
                        " " +
                        studentaddmission.lastname}{" "}
                      ({studentaddmission.classname || studentaddmission.class_name}{" "}
                      {studentaddmission.section_name})
                    </h5>
                  </Col>
                  <Col lg={6} className="d-flex justify-content-end">
                    {(canEdit ||
                      userInfo?.userrole === "SYS_ADMIN" ||
                      userInfo?.userrole === "ADMIN") && (
                        <Button
                          className="btn-sm mr-2 mx-2"
                          onClick={() => editStudent(true)}
                          disabled={isCurrentSession === false ? true : false}
                        >
                          Edit Student Admission
                        </Button>
                      )}

                    <Button
                      className="btn-sm mr-2 mx-2"
                      onClick={() => handleFeeDepositClick()}
                    >
                      Fee Deposit
                    </Button>

                    {/* Download 360 Button */}
                    <Button
                      className="btn-sm mr-2 mx-2"
                      onClick={() => handleDownloadClick()}
                    >
                      360 Report
                    </Button>

                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col></Col>
              <div className="px-4 mt-2">
                <StudentAddRelatedList
                  studentaddmission={studentaddmission}
                  onValueChange={handleValueFromChild}
                />
              </div>
            </Row>
          </Container>
        )}
      </div>

      {/* Download 360 Preview Modal - Using Component */}
      <Student360Report
        show={show360Modal}
        onHide={handleCloseModal}
        studentData={studentData}
        userInfo={userInfo}
        title="Student 360° Report"
      />
    </>
  );
};

export default StudentAddmissionView;